<script>
import pdf from 'vue-pdf'
import View from '@/views/View'

export default {
  name: 'PrivacyPolicyPage',
  metaInfo: { title: 'Privacy Policy' },
  extends: View,
  components: {
    pdf,
    componentFooter: () => import('./sections/Footer.vue')
  }
}
</script>

<template>
  <div>
    <pdf src="./privacypolicy.pdf"></pdf>
    <componentFooter />
  </div>
</template>
